@if (!isOnboardingComplete) {

@switch (onboardingStage) {
@case ('link-first-store') {
<app-alternative-content [config]="dashboardAlternativeContentConfig()">
</app-alternative-content>
<div class="dashboard-invitations-section">
  @if(pendingInvitationsCount() > 0) {
  <div class="dashboard-invitations-section__label">{{ 'dashboard.no_data.pendingInvitationsLabel' | translate }}</div>
  }
  <div class="dashboard-invitations-section__cards">
    <app-shared-with-me
      viewMode="cards"
      (invitationsCount)="pendingInvitationsCount.set($event)"
      (accepted)="onDashboardInvitationAccepted($event)">
    </app-shared-with-me>
  </div>
</div>
}
@case ('finish-store-setup') {
<app-alternative-content [config]="storesIncompleteAlternativeContentConfig">
</app-alternative-content>
}
@default {
<app-alternative-content [config]="storesCompleteButOnboardingIncompleteAlternativeContentConfig">
</app-alternative-content>
}
}
}@else{

@if(stores.length === 0) {
<app-alternative-content [config]="dashboardAlternativeContentConfig()">
</app-alternative-content>
}@else if (stores.length > 0 && allStoresIncomplete ) {
<app-alternative-content [config]="storesIncompleteAlternativeContentConfig">
</app-alternative-content>
}@else {
<div class="dashboard-page">
<div class="dashboard-layout">
  <aside class="filters-aside cardWithShadow">
    <form [formGroup]="filterForm" class="filters-form">
      <div class="filters-aside-header">
        <h3 class="filters-aside-page-title">{{ 'dashboard.dashboard' | translate }}</h3>
        <div class="filters-aside-filters-row">
          <h4 class="filters-title">{{ 'dashboard.filters' | translate }}</h4>
          <div class="filters-aside-actions">
            <button type="button" mat-stroked-button class="filters-action-btn"
              [matTooltip]="'dashboard.clearFilter' | translate" [disabled]="!isFilterModified()"
              (click)="clearFilters()">
              <i-tabler name="filter-off" class="icon-18"></i-tabler>
            </button>
          </div>
        </div>
      </div>

      <div class="filters-aside-body">
        @if(showProviderFilter) {
        @if (onlyOneProvider) {
        <mat-form-field appearance="outline" class="hide-hint w-100 filter-field-readonly">
          <mat-label>{{ 'dashboard.select_provider_label' | translate }}</mat-label>
          <input matInput [value]="singleProviderName" readonly />
        </mat-form-field>
        } @else {
        <mat-form-field appearance="outline" class="hide-hint w-100">
          <mat-label>{{ 'dashboard.select_provider_label' | translate }}</mat-label>
          <mat-select formControlName="provider">
            <mat-option [value]="">{{ 'dashboard.all' | translate }}</mat-option>
            @for (provider of providerOptions; track provider.value) {
            <mat-option [value]="provider.value">{{ provider.name }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
        }
        }
        @if(showStoreFilter) {
        @if (onlyOneStore) {
        <mat-form-field appearance="outline" class="hide-hint w-100 filter-field-readonly">
          <mat-label>{{ 'dashboard.select_store_label' | translate }}</mat-label>
          <input matInput [value]="singleStoreName" readonly />
        </mat-form-field>
        } @else {
        <mat-form-field appearance="outline" class="hide-hint w-100">
          <mat-label>{{ 'dashboard.select_store_label' | translate }}</mat-label>
          <mat-select formControlName="store">
            <mat-option [value]="">{{ 'dashboard.all' | translate }}</mat-option>
            @for (store of filteredStores; track store.storeId) {
            <mat-option [value]="store.storeId">{{ store.name }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
        }
        }
        <section class="filter-section">
          <app-date-range-selector [label]="'dashboard.select_range_label' | translate" [options]="rangeDateOptions"
            [value]="{ startDate: filterForm.value.startDate, endDate: filterForm.value.endDate }"
            (valueChange)="onDateRangeChange($event, 'startDate', 'endDate')" [translateKeyPrefix]="'dashboard'">
          </app-date-range-selector>
        </section>
      </div>

      <hr class="filters-aside-divider" aria-hidden="true" />

      <p class="filters-aside-footnote filters-aside-footnote--divider">{{ 'dashboard.filter.hint' | translate }}</p>

      <hr class="filters-aside-divider" aria-hidden="true" />

      <app-dashboard-store-config-status-widget [stores]="stores" />

      <hr class="filters-aside-divider" aria-hidden="true" />

      @if (!allStoresDelegated) {
      <app-dashboard-usage-widget />
      }
    </form>
  </aside>

  <main class="dashboard-main">
<section class="dashboard-section dashboard-section--primary">
  <div [appColCount]="[1, 1, 8]" gap="0.625rem">
    <div [appColSpan]="2">
      <app-dashboard-case-overview-widget
        [kpi]="widgetKpis.caseOverview"
        [listNavigation]="listNavigationContext" />
    </div>

    <div [appColSpan]="3">
      <app-dashboard-case-status-widget
        [kpi]="widgetKpis.caseStatus"
        [listNavigation]="listNavigationContext" />
    </div>

    <div [appColSpan]="3">
      <app-dashboard-opportunity-value-widget
        [kpi]="widgetKpis.opportunityValue"
        [listNavigation]="listNavigationContext" />
    </div>
  </div>
</section>

<section class="dashboard-section dashboard-section--secondary">
  <div [appColCount]="[1,2,4]" gap="0.625rem">
    <div [appColSpan]="2">
      <app-dashboard-other-claims-widget
        [kpi]="widgetKpis.otherClaims"
        [claimTypes]="claimTypes"
        [listNavigation]="listNavigationContext" />
    </div>

    <!-- Lost Inbound widget hidden until claim discovery is supported (phase 1). -->
    <!-- ... -->
    <div [appColSpan]="1">
      <app-dashboard-lost-outbound-claim-widget
        [kpi]="widgetKpis.lostOutbound"
        [listNavigation]="listNavigationContext" />
    </div>

    <div [appColSpan]="1">
      <mat-card class="cardWithShadow dashboard-card">
        <mat-card-content class="dashboard-card-content">
          <app-dashboard-reimbursement-summary-widget
            [totalReimbursement]="widgetKpis.storeProviderReport.totalReimbursement"
            [totalCashReimbursement]="widgetKpis.storeProviderReport.totalCashReimbursement"
            [totalInventoryReimbursement]="widgetKpis.storeProviderReport.totalInventoryReimbursement"
            [listNavigation]="listNavigationContext" />
        </mat-card-content>
      </mat-card>
    </div>
  </div>
</section>

<section class="dashboard-section dashboard-section--report">
  <app-dashboard-store-provider-report-widget
    #storeProviderReportWidget
    [kpi]="widgetKpis.storeProviderReport"
    [providers]="providers" />
</section>
  </main>
</div>
</div>
}
}
